import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import Loader from "../loader";

import { LayoutContext } from "../layout/";
import { getEndpoint } from "../helper";

export default function BrandFile({ }) {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const { brandId } = useParams();

    const { setPageTitle } = useContext(LayoutContext);

    const Box = ({ id, title, description, fileName }) => {
        return (
            <Link className='box d-f bc-w bw-1 bc--n3 br-3 mb-4' to={`/brand-file-fs/${brandId}/${id}`}>
                <div className='fsh-0 fg-0' style={{ backgroundColor: '#dddddd', width: '28%' }}>
                    {
                        fileName.indexOf('.mp4') > 0
                            ? <img src={getEndpoint('/pwa/img/video_player.png')} />
                            : <img src={getEndpoint(`/uploads/shop/brand-file/thumb/${fileName}`)} />
                    }
                </div>
                <div className='px-2 mt-2' style={{ width: '82%' }}>
                    <div>{title}</div>
                    {description != null && description != '' && <div className='mt-3 mb-2' style={{ fontSize: '.86em', color: '#777', lineHeight: '1.2' }}>{description}</div>}
                </div>
            </Link>
        );
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(`/api/android/brand/GetMedia?brandId=${brandId}`), { signal });
                const json = await response.json();
                setData(json.data);

                setPageTitle(json.data[0].brandTitle);

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='p-4'>
            {data.filter(x => x.title != null && x.title != '').map((x, i) => {
                return (
                    <Box
                        key={x.id}
                        id={x.id}
                        title={x.title}
                        fileName={x.fileName}
                        description={x.description}
                    />
                )
            })}
            {data.length > 0 && data[0].brandDescription && (
                <div className='box br-3 bc-w pt-2 px-4 pb-4'>
                    <div>توضیحات:</div>
                    <div className='mt-3' style={{ fontSize: '.9em', color: '#777', lineHeight: '1.4' }}>{data[0].brandDescription}</div>
                </div>
            )}
        </div>
    );
}